// packages/eden-utilities/src/utils/adjustHexAlpha.js
var adjustHexAlpha = (color, opacity) => color + ("0" + Math.round(255 * opacity).toString(16)).slice(-2);
var adjustHexAlpha_default = adjustHexAlpha;
export {
  adjustHexAlpha_default as default
};
